import { ref, watch, type Ref } from "vue";
import type { AreaListItem, AreaSelectValue } from "../types";

/**
 * 検索フォームの入力状態と操作を提供する composable。
 *
 * @returns 画面フォームで利用する状態と操作関数
 */
export const useRegularDeliverySearchForm = () => {
  // 会員番号
  const searchConditionMemberId = ref<string | undefined | null>(null);

  // お名前(漢字・かな)
  const searchConditionName = ref<string | undefined | null>(null);

  // 配達エリア
  const searchConditionAreaCode = ref<string | undefined | null>(null);

  /**
   * エリアリスト
   */
  const areaListItems = ref<AreaListItem[] | null | undefined>([]);
  const areaSelectValues = ref<AreaSelectValue>(null);

  const syncSearchAreaCode = (): void => {
    searchConditionAreaCode.value =
      areaSelectValues.value && areaSelectValues.value.area_code !== ""
        ? areaSelectValues.value.area_code
        : null;
  };

  watch(
    () => areaSelectValues.value,
    () => {
      syncSearchAreaCode();
    }
  );

  return {
    searchConditionMemberId,
    searchConditionName,
    searchConditionAreaCode,
    areaListItems,
    areaSelectValues,
    syncSearchAreaCode,
  };
};
